import { render, staticRenderFns } from "./Programa-viewrest.vue?vue&type=template&id=2bda9077&scoped=true"
import script from "./Programa-viewrest.vue?vue&type=script&lang=js"
export * from "./Programa-viewrest.vue?vue&type=script&lang=js"
import style0 from "./Programa-viewrest.vue?vue&type=style&index=0&id=2bda9077&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bda9077",
  null
  
)

export default component.exports